/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: workflow.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CloneWorkflowRequest,
  CloneWorkflowResponse,
  CreateWorkflowRequest,
  CreateWorkflowResponse,
  GetWorkflowRequest,
  GetWorkflowResponse,
  GetWorkflowsByProgramRequest,
  GetWorkflowsByProgramResponse,
  ListOrganizationWorkflowsRequest,
  ListOrganizationWorkflowsResponse,
  UpdateWorkflowRequest,
  UpdateWorkflowResponse,
} from '../types/workflow';

export const createWorkflowService = (transport: Transport) => ({
  async getWorkflowsByProgram(
    request: GetWorkflowsByProgramRequest,
    options: RequestOptions = {},
  ): Promise<GetWorkflowsByProgramResponse> {
    const { organization_id, program_id } = request;
    const url = getApiPath(API_METHODS.WorkflowService.GetWorkflowsByProgram, {
      organization_id,
      program_id,
    });
    return transport.get<GetWorkflowsByProgramResponse>(url, options);
  },

  async listOrganizationWorkflows(
    request: ListOrganizationWorkflowsRequest,
    options: RequestOptions = {},
  ): Promise<ListOrganizationWorkflowsResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.WorkflowService.ListOrganizationWorkflows, {
      organization_id,
    });
    return transport.get<ListOrganizationWorkflowsResponse>(url, { params, ...options });
  },

  async getWorkflow(
    request: GetWorkflowRequest,
    options: RequestOptions = {},
  ): Promise<GetWorkflowResponse> {
    const { organization_id, program_id, workflow_id } = request;
    const url = getApiPath(API_METHODS.WorkflowService.GetWorkflow, {
      organization_id,
      program_id,
      workflow_id,
    });
    return transport.get<GetWorkflowResponse>(url, options);
  },

  async updateWorkflow(
    request: UpdateWorkflowRequest,
    options: RequestOptions = {},
  ): Promise<UpdateWorkflowResponse> {
    const { organization_id, program_id, workflow_id, ...body } = request;
    const url = getApiPath(API_METHODS.WorkflowService.UpdateWorkflow, {
      organization_id,
      program_id,
      workflow_id,
    });
    return transport.post<UpdateWorkflowResponse>(url, body, options);
  },

  async createWorkflow(
    request: CreateWorkflowRequest,
    options: RequestOptions = {},
  ): Promise<CreateWorkflowResponse> {
    const { organization_id, program_id, ...body } = request;
    const url = getApiPath(API_METHODS.WorkflowService.CreateWorkflow, {
      organization_id,
      program_id,
    });
    return transport.post<CreateWorkflowResponse>(url, body, options);
  },

  async cloneWorkflow(
    request: CloneWorkflowRequest,
    options: RequestOptions = {},
  ): Promise<CloneWorkflowResponse> {
    const { organization_id, program_id, workflow_id, ...body } = request;
    const url = getApiPath(API_METHODS.WorkflowService.CloneWorkflow, {
      organization_id,
      program_id,
      workflow_id,
    });
    return transport.post<CloneWorkflowResponse>(url, body, options);
  },
});

export type WorkflowService = ReturnType<typeof createWorkflowService>;
